import { observer } from 'mobx-react';
import { FC } from 'react';
import DeliveryConditionControls from '../../components/DeliveryConditionControls/DeliveryConditionControls';
import branchEditStore from '../../store/branchEditStore';
import { BRANCH_DELIVERY_CONDITION, SETTINGS_DELIVERY_TYPE } from 'src/types/branches';
import Text, { TEXT } from 'src/view/components/Text/Text';

const MinimumOrderCondition: FC = observer((): JSX.Element => {
  const onChangeStatus = (status: string | number) => {
    branchEditStore.changeBranchData({ min_order_type: status as BRANCH_DELIVERY_CONDITION });
  };

  const onChangeFixedValue = (value: string) => {
    branchEditStore.changeBranchData({ min_order: value });
  };

  return (
    <div className="d-flex flex-column">
      <Text text="branch_min_order_header" type={TEXT.BLOCK_HEADER} />
      <DeliveryConditionControls
        type={SETTINGS_DELIVERY_TYPE.MIN_ORDER}
        status={branchEditStore.editableBranch.min_order_type}
        fixedValue={String(branchEditStore.editableBranch.min_order)}
        onChangeStatus={onChangeStatus}
        onChangeFixedValue={onChangeFixedValue}
      />
    </div>
  );
});

export default MinimumOrderCondition;
